import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { Check } from 'lucide-react';
import 'react-circular-progressbar/dist/styles.css';

const ProgressCircle = ({ 
  percentage = 0, 
  size = 24, 
  strokeWidth = 4,
  showText = false,
  textSize = 12,
  color = 'var(--brand-blue)',
  trailColor = 'var(--border-color)'
}) => {
  // Show green checkmark when progress is complete
  if (percentage >= 100) {
    return (
      <div style={{ width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Check size={size} color="#10B981" strokeWidth={3} />
      </div>
    );
  }

  return (
    <div style={{ width: size, height: size  }}>
      <CircularProgressbar
        value={percentage}
        text={showText ? `${percentage}%` : ''}
        styles={buildStyles({
          // Rotation of path and trail, in number of turns (0-1)
          rotation: 0.25,
          
          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: 'round',
          
          // Text size
          textSize: textSize,
          
          // How long animation takes to go from one percentage to another, in seconds
          pathTransitionDuration: 0.5,
          
          // Can specify path transition in more detail, or remove it entirely
          // pathTransition: 'none',
          
          // Colors
          pathColor: color,
          textColor: 'var(--text-primary)',
          trailColor: trailColor,
        })}
        strokeWidth={strokeWidth}
      />
    </div>
  );
};

export default ProgressCircle; 